import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Text, Flex } from "sprout-ui-primitives";
import { ItemType } from "sprout-graphql";
import { media } from "sprout-ui-theme";
import { CheckCircleOutlineOutlined, OrderBoolAscendingVariant } from "sprout-ui-icons";
const LineClamp = styled(Text).attrs({
    as: "span"
})`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  ${"" /* overflow-wrap: break-word; */ };
  ${"" /* word-wrap is alias to overflow-wrap */ };
  ${"" /* word-wrap: break-word */ };

  line-height: 24px;
  /* line-clamp * line-height */
  max-height: 48px;
`;
const PostPageBreadcrumbsTodoListWrapper = styled(Flex)`
  ${media.target("pointer")} {
    &:hover {
      ${LineClamp} {
        text-decoration: underline;
      }
    }
  }
`;
const PostPageBreadcrumbsTodoList = (props)=>{
    const { type , description , itemId  } = props;
    const to = type === ItemType.Checklist ? `/todolist/${itemId}` : `/todo/${itemId}`;
    return /*#__PURE__*/ _jsxs(PostPageBreadcrumbsTodoListWrapper, {
        alignItems: "center",
        as: Link,
        to: to,
        bg: "white.100",
        borderRadius: "30px",
        py: 0,
        px: 3,
        children: [
            /*#__PURE__*/ _jsx(Flex, {
                alignItems: "center",
                justifyContent: "center",
                mr: 1,
                children: /*#__PURE__*/ createElement(type === ItemType.Checklist ? OrderBoolAscendingVariant : CheckCircleOutlineOutlined)
            }),
            /*#__PURE__*/ _jsx(LineClamp, {
                color: "blue.500",
                children: description
            })
        ]
    });
};
export default PostPageBreadcrumbsTodoList;
